import landingpageParallax from './modules/landingpage-parallax';

window.addEventListener('load', landingpageParallax);
